export enum ErrorType {
  UserError,
  EmptyError,
  RevertError,
  PanicError,
  UnknownError,
  CustomError,
}
